import React, { Component } from "react";
import {
  StyledButton,
  DataTable,
  Loadable,
  ViewSaleButton,
  SaleStatusSemaphore,
  CurrencyValue
} from "components/support";
import { colors } from "assets";
import Icon from "material-ui-next/Icon";
import Paper from "material-ui-next/Paper";
import { SaleStatus, PaymentTypes } from "core/enum";

class DataTableWrapper extends Component {
  config = {
    identifier: "id",
    columns: [
      {
        accessor: "id",
        show: false
      },
      {
        accessor: "activated_at",
        type: "datetime",
        align: "center",
        Header: "Data",
        minWidth: 80
      },
      {
        Header: "Total",
        align: "right",
        minWidth: 80,
        sortable: false,
        Cell: props => (
          <CurrencyValue
            value={props.row._original.total_value * 100}
            type="money"
          />
        )
      },
      {
        id: "document_number",
        Header: "Comprovante",
        width: 160,
        Cell: props => <ViewSaleButton sale={props.row._original} />
      },
      {
        id: "customer",
        Header: "Cliente",
        Cell: props => (
          <div>{props.row._original.getCustomer().identifier()}</div>
        )
      },
      {
        id: "payment_type",
        Header: "Meio de Pag.",
        Cell: props => (
          <div>{this.formatPaymentType(props.row._original.payments)}</div>
        ),
        sortable: false
      },
      {
        accessor: "status",
        Header: "Status",
        type: "enum",
        align: "center",
        params: { enum: SaleStatus },
        sortable: false,
        Cell: props => {
          const { status, document } = props.row._original;
          const description =
            document && document.sefaz_status
              ? document.sefaz_status.description
              : "";
          const code =
            document && document.sefaz_status ? document.sefaz_status.code : "";
          const type = document ? document.type : "";
          return (
            <SaleStatusSemaphore
              status={status}
              description={description}
              code={code}
              type={type}
            />
          );
        }
      },
      {
        accessor: "pos_operator.name",
        Header: "Caixa",
        sortable: false
      },
      {
        accessor: "salesman.name",
        Header: "Vendedor",
        sortable: false
      },
      {
        id: "actions",
        Header: "Ações",
        align: "center",
        width: 80,
        sortable: false,
        filterable: false,
        Cell: props => this.saleActions(props.row._original)
      }
    ]
  };

  formatPaymentType(payments) {
    return payments
      .map(payment =>
        payment.type === "credit_card" && payment.installments > 1
          ? "Crédito (Parcelado)"
          : PaymentTypes[payment.type] || payment.type
      )
      .join(", ");
  }

  saleActions(sale) {
    if (sale.can_cancel) {
      return (
        <div>
          <StyledButton
            flat
            accent
            style={{
              color: colors.accent.normal,
              padding: "0px",
              fontSize: "12px",
              margin: "0px",
              border: "none"
            }}
            label="Cancelar"
            onClick={() => this.props.onDelete(sale)}
          />
        </div>
      );
    } else if (sale.cancel_reason) {
      return (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => this.props.presenter.onShowCannotCancelReason(sale)}
        >
          <Icon style={{ padding: 0 }}>warning</Icon>
        </div>
      );
    }
  }

  render() {
    const {
      viewModel,
      order,
      handlePageChange,
      content,
      pagination,
      handleDataTableChange
    } = this.props;
    const loading = this.props.loading || viewModel.loading;
    return (
      <Loadable loading={loading}>
        <Paper elevation={1}>
          <DataTable
            manual
            filterable={false}
            defaultSorted={[
              {
                id: "created_at",
                desc: true
              }
            ]}
            resultSet={content}
            total={pagination.total}
            perPage={pagination.perPage}
            page={pagination.currentPage}
            config={this.config}
            onChange={handleDataTableChange}
            orderField={order.field}
            orderDirection={order.direction}
            onPageChange={page => handlePageChange(page + 1)}
          />
        </Paper>
      </Loadable>
    );
  }
}

export default DataTableWrapper;



// WEBPACK FOOTER //
// ./src/components/app/history/sales/data-table/view.jsx